var _style, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconControlPanel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 110 110",
    style: {
      enableBackground: "new 0 0 110 110"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.stcp{fill:#333333;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stcp",
    d: "M84.5,26H27.1c-2.8,0-5.1,2.3-5.1,5.1v39.5c0,2.8,2.3,5.1,5.1,5.1h19.8v6.6h-7.3v3h32.5v-3h-7.3v-6.6h19.8 c2.8,0,5.1-2.3,5.1-5.1V31.1C89.6,28.3,87.3,26,84.5,26L84.5,26z M49.8,82.2v-6h12v6H49.8z M86.6,70.6c0,1.1-0.9,2.1-2.1,2.1H27.1 c-1.1,0-2.1-0.9-2.1-2.1V31.1c0-1.1,0.9-2.1,2.1-2.1h57.5c1.1,0,2.1,0.9,2.1,2.1V70.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "stcp",
    d: "M51,36.5c0-1.6-1.3-2.9-2.9-2.9h-3.7c-1.6,0-2.9,1.3-2.9,2.9v5.3c0,1.6,1.3,2.9,2.9,2.9h3.7 c1.6,0,2.9-1.3,2.9-2.9v-1.1h19.1v-3H51V36.5L51,36.5z M48,41.6h-3.4v-5H48V41.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "stcp",
    d: "M67.2,57.1h-3.7c-1.6,0-2.9,1.3-2.9,2.9v1.1h-19v3h19.1v1.1c0,1.6,1.3,2.9,2.9,2.9h3.7c1.6,0,2.9-1.3,2.9-2.9 v-5.3C70,58.3,68.8,57.1,67.2,57.1L67.2,57.1z M67,65.1h-3.4v-5H67V65.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "stcp",
    d: "M60.5,48.2c0-1.6-1.3-2.9-2.9-2.9H54c-1.6,0-2.9,1.3-2.9,2.9v1.1h-9.3v3h9.3v1.1c0,1.6,1.3,2.9,2.9,2.9h3.7 c1.6,0,2.9-1.3,2.9-2.9v-1.1h9.5v-3h-9.5V48.2z M57.5,53.3h-3.4v-5h3.4V53.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconControlPanel);
export default __webpack_public_path__ + "static/media/icon-control-panel.4cbdb36371eed57fa878c881bc11a494.svg";
export { ForwardRef as ReactComponent };